import { Navigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import MeetingView from "./meeting-view/MeetingView";
import MeetingPage from "./meeting-page/Root";
import { useDispatch } from "react-redux";
import { setTheme } from "../actions";
import { conferenceSessionStorage } from "conference/tools";
import { defaultMeetingPageSettings, MeetingPageStage } from "./meeting-page/types";
import MeetingEditPage from "./save-meeting/MeetingEditPage";
import Page from "conference/components/main-frame/Page";
import SaveMeetingForm, { emptyInitialFormData } from "./save-meeting/SaveMeetingForm";
import { defineMessage } from "react-intl";

export const MeetingEditorController = () => {
    const { id } = useParams<{ id: string }>();

    return <MeetingEditPage meetingId={parseInt(id)} />;
};

export const CreateMeetingController = () => {
    return (
        <Page
            title={defineMessage({ id: "title.createMeeting", defaultMessage: "Create meeting" })}
            subtitle={defineMessage({
                id: "title.createMeetingSubtitle",
                defaultMessage: "Schedule meeting in the future",
            })}
        >
            <SaveMeetingForm
                initialFormData={emptyInitialFormData}
                successNotification={defineMessage({
                    id: "meeting.success.create",
                    defaultMessage: "The meeting has been created.",
                })}
            />
        </Page>
    );
};

export const MeetingViewController = () => {
    const { id } = useParams<{ id: string }>();

    return <MeetingView id={parseInt(id)} />;
};

export const MeetingPageController = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setTheme("dark"));
        return () => {
            dispatch(setTheme("light"));
        };
    }, []);

    return <MeetingPage id={parseInt(id)} />;
};

export const BrowserJoinMeetingPageController = () => {
    const { id } = useParams<{ id: string }>();

    conferenceSessionStorage.meetingPageSettings = {
        ...defaultMeetingPageSettings,
        stage: MeetingPageStage.Prepare,
    };

    return <Navigate to={`/meeting/${id}`} replace />;
};
